export {
	getColorClassName,
	getColorObjectByAttributeValues,
	getColorObjectByColorValue,
} from './utils';
export { default as withColors } from './with-colors';
